<template>
  <div class="lawyerRegisterMain">
    <div class="lawyerRegisterHeader">
      <div class="lawyerRegisterTitle">
        <div class="logoIconC">
          <img :src="logoIcon" class="logoIconMini" />
        </div>
        {{baseInfo.name || ''}}
      </div>
      <div class="lawyerRegisterTitleRight">
        <span>
          已有账号？
          <router-link to="/login">前往登录</router-link>
        </span>
      </div>
    </div>
    <div class="lawyerRegisterBody">
      <div class="lrMainConent">
        <div class="lrContent">
          <div class="lrTitleC">
            <div class="lrTitleMain">律师入驻注册</div>
            <div class="lrTitleDesc">填写信息并完成资质认证，审核通过即可入驻平台接单！</div>
          </div>
          <div class="lrSuccessC" v-if="submitStatus">
            <div class="lrSuccess">
              <Icon color="#19be6b" size="90" type="md-checkmark-circle" />
              <div class="lrSuccessTitle">注册申请提交成功</div>
              <div class="lrSuccessDesc">已提交申请，等待运营审核，审核结果将会以邮件的形式发送给您。</div>
            </div>
          </div>

          <div class="formContent" v-else>
            <Alert show-icon style="margin: 20px 20px 0 20px" type="warning">
              ‼️重要提醒
              <div slot="desc">
                <p>1. 请填写正确的手机号，此手机号将作为后续接收短信及承接咨询的手机号！</p>
                <p>2. 请填写正确的联系邮箱，审核结果将以邮件的形式发送！</p>
              </div>
            </Alert>

            <Form
              :model="lawyerForm"
              :rules="lawyerFormValidate"
              ref="lawyerForm"
              style="padding: 1rem"
            >
              <div class="partDivider">律师个人信息</div>

              <Row :gutter="20">
                <Col :md="12" :xs="24">
                  <FormItem label="姓名" prop="lawyerName">
                    <Input placeholder="请输入姓名" type="text" v-model="lawyerForm.lawyerName"></Input>
                  </FormItem>
                </Col>

                <Col :md="12" :xs="24">
                  <FormItem label="手机号" prop="lawyerMobile">
                    <Input placeholder="请输入手机号" type="text" v-model.trim="lawyerForm.lawyerMobile"></Input>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24">
                  <FormItem label="联系邮箱" prop="email">
                    <Input placeholder="请输入邮箱" type="text" v-model.trim="lawyerForm.email"></Input>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24">
                  <FormItem
                    :rules="[{ required: true, validator: (rule, value, callback) => {
            this.$valideUtil.checkPaperCode('ID_CARD', value, callback, rule)
              }, trigger: 'blur' } ]"
                    label="身份证号"
                    prop="paperCode"
                  >
                    <Input
                      @on-blur="changePaperCode"
                      maxlength="40"
                      v-model="lawyerForm.paperCode"
                    />
                  </FormItem>
                </Col>

                <Col :md="12" :xs="24">
                  <FormItem label="执业证号" prop="licenseNumber">
                    <Input
                      placeholder="请输入执业证号"
                      type="text"
                      v-model.trim="lawyerForm.licenseNumber"
                    ></Input>
                  </FormItem>
                </Col>

                <Col :md="12" :xs="24">
                  <FormItem label="执业时间" prop="startWorkDate">
                    <DatePicker
                      @on-change="(val)=>{lawyerForm.startWorkDate = val}"
                      format="yyyy-MM-dd"
                      placeholder="请选择执业时间"
                      style="width: 100%"
                      type="date"
                      v-model="lawyerForm.startWorkDate"
                    ></DatePicker>
                  </FormItem>
                </Col>

                <Col :md="12" :xs="24">
                  <FormItem label="资格证号" prop="qualificationCertificateNumber">
                    <Input
                      placeholder="请输入资格证号"
                      type="text"
                      v-model.trim="lawyerForm.qualificationCertificateNumber"
                    ></Input>
                  </FormItem>
                </Col>

                <Col :md="12" :xs="24">
                  <FormItem label="详细地址" prop="areaCodes">
                    <div class="comboBox" style="width: 100%;">
                      <Cascader
                        :data="regionData"
                        class="left"
                        placeholder="省市区"
                        style="width: 60%"
                        v-model.trim="lawyerForm.areaCodes"
                      ></Cascader>
                      <!-- <FormItem label=" " prop="address"> -->
                      <Input
                        class="right"
                        maxlength="100"
                        placeholder="请输入详细地址"
                        type="text"
                        v-model.trim="lawyerForm.address"
                      ></Input>
                      <!-- </FormItem> -->
                    </div>
                  </FormItem>
                </Col>
                <!-- <Col :md="12" :xs="24">
                  <FormItem label="详细地址" prop="address">
                    <Input
                      maxlength="100"
                      placeholder="请输入详细地址"
                      type="text"
                      v-model.trim="lawyerForm.address"
                    ></Input>
                  </FormItem>
                </Col>-->
                <Col :xs="24">
                  <FormItem label="个人简介" prop="remark">
                    <Input
                      :autosize="{minRows: 2,maxRows: 3}"
                      maxlength="255"
                      show-word-limit
                      type="textarea"
                      v-model.trim="lawyerForm.remark"
                    ></Input>
                  </FormItem>
                </Col>
              </Row>

              <div class="partDivider">
                <div style="display: flex; align-items: center;">
                  律所信息
                  <Tooltip content="录入律所信息" style="width: fit-content; display: flex;">
                    <Icon
                      @click="reportFirm"
                      class="pointer"
                      color="#2d8cf0"
                      size="22"
                      type="md-add"
                    />
                  </Tooltip>
                </div>
              </div>

              <Row :gutter="20">
                <!-- <Divider orientation="left">
                  <div class="flex">
                    律所信息
                    <Tooltip content="录入律所信息" style="width: fit-content;">
                      <Icon
                        @click="reportFirm"
                        class="pointer"
                        color="#2d8cf0"
                        size="22"
                        type="md-add"
                      />
                    </Tooltip>
                  </div>
                </Divider>-->

                <Col :md="12" :xs="24">
                  <FormItem label="所属律所" prop="lawFirmId">
                    <Select
                      @on-change="changeLawFirm"
                      clearable
                      filterable
                      placeholder="请选择律所"
                      transfer
                      v-model="lawyerForm.lawFirmId"
                    >
                      <Option
                        :key="lawFirmOption.value"
                        :label="lawFirmOption.label"
                        :value="lawFirmOption.value"
                        v-for="lawFirmOption in lawFirmOptions"
                      >{{ lawFirmOption.label }}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col :md="12" :xs="24">
                  <FormItem label="入职日期" prop="joinedDate">
                    <Date-picker
                      format="yyyy-MM-dd"
                      placeholder="选择入职日期"
                      style="width: 100%"
                      type="date"
                      v-model="lawyerForm.joinedDate"
                    ></Date-picker>
                  </FormItem>
                </Col>
              </Row>

              <div class="partDivider">执业资质材料（JPG/PNG）</div>
              <Row :gutter="20">
                <!-- <Divider orientation="left">执业资质材料</Divider> -->

                <Col :xs="24">
                  <FormItem :label-width="100" label="身份证照" prop="idCards">
                    <template v-if="idCardList.length>0">
                      <div :key="item.uid" class="sunflower-upload-list" v-for="item in idCardList">
                        <img :src="item.url" v-if="item.getFileType=='image'" />
                        <div :class="`fileIcon ${item.getFileType}Icon`" v-else />
                        <div class="sunflower-upload-list-cover">
                          <Icon @click.native="viewFile(item)" type="md-eye"></Icon>
                          <Icon @click.native="handleRemoveIDCards(item)" type="md-trash"></Icon>
                        </div>
                      </div>
                    </template>
                    <div class="sunflower-upload-list">
                      <sunflowerFileUpload
                        :opts="fileOptsIDCards"
                        @uploadFile="uploadIDCards"
                        ref="uploadIDCards"
                      >
                        <template slot="uploadContent">
                          <div
                            class="pointer"
                            style="width: 58px;height:58px;line-height: 58px;text-align: center;"
                          >
                            <Icon size="20" type="ios-camera"></Icon>
                          </div>
                        </template>
                      </sunflowerFileUpload>
                    </div>
                  </FormItem>
                </Col>

                <Col :xs="24">
                  <FormItem :label-width="100" label="执业证照" prop="lns">
                    <template v-if="lnList.length>0">
                      <div :key="item.uid" class="sunflower-upload-list" v-for="item in lnList">
                        <img :src="item.url" v-if="item.getFileType=='image'" />
                        <div :class="`fileIcon ${item.getFileType}Icon`" v-else />
                        <div class="sunflower-upload-list-cover">
                          <Icon @click.native="viewFile(item)" type="md-eye"></Icon>
                          <Icon @click.native="handleRemoveLn(item)" type="md-trash"></Icon>
                        </div>
                      </div>
                    </template>
                    <div class="sunflower-upload-list">
                      <sunflowerFileUpload :opts="fileOptsLn" @uploadFile="uploadLn" ref="uploadLn">
                        <template slot="uploadContent">
                          <div
                            class="pointer"
                            style="width: 58px;height:58px;line-height: 58px;text-align: center;"
                          >
                            <Icon size="20" type="ios-camera"></Icon>
                          </div>
                        </template>
                      </sunflowerFileUpload>
                    </div>
                  </FormItem>
                </Col>

                <Col :xs="24">
                  <FormItem :label-width="100" label="资格证照" prop="qcs">
                    <template v-if="qcList.length>0">
                      <div :key="item.uid" class="sunflower-upload-list" v-for="item in qcList">
                        <img :src="item.url" v-if="item.getFileType=='image'" />
                        <div :class="`fileIcon ${item.getFileType}Icon`" v-else />
                        <div class="sunflower-upload-list-cover">
                          <Icon @click.native="viewFile(item)" type="md-eye"></Icon>
                          <Icon @click.native="handleRemoveQc(item)" type="md-trash"></Icon>
                        </div>
                      </div>
                    </template>
                    <div class="sunflower-upload-list">
                      <sunflowerFileUpload :opts="fileOptsQc" @uploadFile="uploadQc" ref="uploadQc">
                        <template slot="uploadContent">
                          <div
                            class="pointer"
                            style="width: 58px;height:58px;line-height: 58px;text-align: center;"
                          >
                            <Icon size="20" type="ios-camera"></Icon>
                          </div>
                        </template>
                      </sunflowerFileUpload>
                    </div>
                  </FormItem>
                </Col>
              </Row>
              <div class="checkBox">
                <p>
                  <Checkbox v-model="checkBox">
                    我已阅读并同意
                    <a @click="viewRZXY" href="javascript:void(0)">《律师入驻服务协议》</a>
                  </Checkbox>
                </p>
                <p>
                  <Checkbox v-model="checkBoxP">
                    我已阅读并同意
                    <a @click="viewYSZC" href="javascript:void(0)">《律师入驻保密与信息安全承诺书》</a>
                  </Checkbox>
                </p>
              </div>
              <Row justify="center" type="flex">
                <Divider />
                <Col :md="6" :xs="6">
                  <Button @click="handleSubmit" long type="primary">提交审核</Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="copyright" v-if="baseInfo.copyRight">{{baseInfo.copyRight || ''}}</div> -->
    <Modal
      :title="'预览--'+ viewFileData.name"
      @on-cancel="()=>{this.showPreview= false}"
      fullscreen
      v-model="showPreview"
    >
      <filePreview :fileOption="viewFileData" v-if="showPreview"></filePreview>
    </Modal>

    <Modal @on-cancel="cancelFirmEdit" title="录入律所信息" v-model="addFirm" width="50vw">
      <Form :label-width="120" :model="lawFirmForm" :rules="lawFirmFormValidate" ref="lawFirmForm">
        <Row>
          <Col :sm="12" :xs="24">
            <FormItem label="律所名称" prop="lawFirmName">
              <Input placeholder="请输入律所名称" type="text" v-model.trim="lawFirmForm.lawFirmName"></Input>
            </FormItem>
          </Col>

          <Col :sm="12" :xs="24">
            <FormItem label="社会信用代码" prop="socialCreditCode">
              <Input
                :maxlength="18"
                placeholder="请输入18位社会信用代码"
                type="text"
                v-model.trim="lawFirmForm.socialCreditCode"
              ></Input>
            </FormItem>
          </Col>

          <!-- <Col :sm="12" :xs="24">
            <FormItem label="执业状态" prop="practiceStatus">
              <Select clearable filterable v-model="lawFirmForm.practiceStatus">
                <Option
                  :key="key"
                  :value="key"
                  v-for="(item, key) in $common.practiceStatus"
                >{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>-->

          <Col :sm="12" :xs="24">
            <FormItem label="律所类型" prop="lawFirmType">
              <Select clearable filterable v-model="lawFirmForm.lawFirmType">
                <Option
                  :key="item.value"
                  :value="item.value"
                  v-for="item in $common.lawfirmTypes"
                >{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>

          <!-- <Col :sm="12" :xs="24">

            <FormItem label="邮编" prop="zipCode">
              <Input placeholder="请输入邮编" type="text" v-model.trim="lawFirmForm.zipCode"></Input>
            </FormItem>
          </Col>-->
          <Col :sm="12" :xs="24">
            <FormItem label="成立日期" prop="establishDate">
              <Date-picker
                @on-change="(val)=>{lawFirmForm.establishDate = val}"
                format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
                type="date"
                v-model="lawFirmForm.establishDate"
              ></Date-picker>
            </FormItem>
          </Col>
          <Col :sm="12" :xs="24">
            <FormItem label="负责人" prop="director">
              <Input placeholder="请输入负责人" type="text" v-model.trim="lawFirmForm.director"></Input>
            </FormItem>
          </Col>

          <Col :sm="12" :xs="24">
            <FormItem label="联系电话" prop="tel">
              <Input placeholder="请输入联系电话" type="text" v-model.trim="lawFirmForm.tel"></Input>
            </FormItem>
          </Col>

          <Col :xs="24">
            <FormItem label="所属区域" prop="areaCodes">
              <div class="comboBox">
                <Cascader
                  :data="regionData"
                  class="left"
                  placeholder="省市区"
                  style="width: 200px;max-width: 200px;"
                  v-model.trim="lawFirmForm.areaCodes"
                ></Cascader>
                <Input
                  class="right"
                  maxlength="100"
                  placeholder="请输入详细地址"
                  show-word-limit
                  type="text"
                  v-model.trim="lawFirmForm.address"
                ></Input>
              </div>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="律所描述" prop="description">
          <Input
            :autosize="{minRows: 2,maxRows: 5}"
            maxlength="255"
            placeholder="请输入律所描述"
            show-word-limit
            type="textarea"
            v-model="lawFirmForm.description"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelFirmEdit" ghost type="primary">取消</Button>
        <Button @click="saveFirm" type="primary">确定</Button>
      </div>
    </Modal>

    <Modal @on-cancel="cancelRZXY" title="律师入驻服务协议" v-model="rzxyView" width="50vw">
      <div style="max-height: 70vh;overflow-y: auto;">
        <lawyerServiceFile
          :checked="checkBox"
          @change="(val) => {this.checkBox=val}"
          v-if="rzxyView"
        ></lawyerServiceFile>
      </div>
      <div slot="footer">
        <Button @click="acceptRZXY" long type="primary">阅读并同意</Button>
      </div>
    </Modal>

    <Modal @on-cancel="cancelYSZC" title="律师入驻保密与信息安全承诺书" v-model="yszcView" width="50vw">
      <div style="max-height: 70vh;overflow-y: auto;">
        <lawyerSecurityFile
          :checked="checkBoxP"
          @change="(val) => {this.checkBoxP=val}"
          v-if="yszcView"
        ></lawyerSecurityFile>
      </div>
      <div slot="footer">
        <Button @click="acceptYSZC" long type="primary">阅读并同意</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import lawyerServiceFile from './lawyerServiceFile.vue'
import lawyerSecurityFile from './lawyerSecurityFile.vue'
export default {
  name: 'lawyerRegister',
  components: {
    lawyerServiceFile, lawyerSecurityFile
  },
  data () {
    const checkName = (rule, value, callback) => {
      let reg = /^[-_#."/()a-zA-z0-9\u4e00-\u9fa5]{1,50}$/
      if (value === undefined || value.trim() === "") {
        callback(new Error("名称不能为空"))
      } else if (!reg.test(value)) {
        callback(new Error("只支持英文大小、数字、中文及‘-_#.\"/()’的1-50位组合"))
      } else {
        callback()
      }
    }
    const checkQcs = (rule, value, callback) => {
      if (this.qcList === undefined || this.qcList.length === 0) {
        callback(new Error("律师资格证照不能为空"))
      } else {
        callback()
      }
    }
    const checkLns = (rule, value, callback) => {
      if (this.lnList === undefined || this.lnList.length === 0) {
        callback(new Error("律师执业证照不能为空"))
      } else {
        callback()
      }
    }
    const checkIdCards = (rule, value, callback) => {
      if (this.idCardList === undefined || this.idCardList.length === 0) {
        callback(new Error("身份证照不能为空"))
      } else {
        callback()
      }
    }

    const checkSocialCreditCode = (rule, value, callback) => {
      let reg = /^[a-zA-z0-9]{18}$/
      if (value === undefined || value === "") {
        callback(new Error("编码不能为空"))
      } else if (!reg.test(value)) {
        callback(new Error("请输入18位社会统一信用代码"))
      } else {
        callback()
      }
    }

    const checkLirmName = (rule, value, callback) => {
      let reg = /^[-_#."/()（）a-zA-z0-9\u4e00-\u9fa5]{1,50}$/
      if (value === undefined || value.trim() === "") {
        callback(new Error("名称不能为空"))
      } else if (!reg.test(value)) {
        callback(new Error("只支持英文大小、数字、中文及‘-_#.\"/()（）’的1-50位组合"))
      } else {
        callback()
      }
    }

    return {
      rzxyView: false,
      yszcView: false,
      checkBox: false,
      checkBoxP: false,
      logoIcon: require('@/assets/static/images/logo_mini.png'),
      baseInfo: {},
      regionData: [],
      lawyerFormValidate: {
        lawyerName: [{ required: true, validator: checkName, trigger: "blur" }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式错误', trigger: 'blur' }
        ],
        lawyerMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { type: 'string', pattern: /^1[3456789]\d{9}$/, message: '手机号格式有误', trigger: 'blur' }
        ],
        licenseNumber: [{ required: true, message: '请输入执业证号', trigger: "blur" }],
        // qualificationCertificateNumber: [{ required: true, message: '请输入资格证号', trigger: "blur" }],
        startWorkDate: [{ required: true, message: '请选择执业时间', trigger: 'blur', pattern: /.+/ }],
        // qcs: [{ required: true, type: 'array', validator: checkQcs, trigger: 'change' }],
        lns: [{ required: true, type: 'array', validator: checkLns, trigger: 'change' }],
        idCards: [{ required: true, type: 'array', validator: checkIdCards, trigger: 'change' }],
      },
      lawyerForm: {
        gender: '',// 性别
        paperType: 'ID_CARD',//证件类型
        paperCode: '', //证件编码
        areaCodes: [],
        birthday: null,//出生日期
        qualificationCertificateNumber: '',//资格证号
        licenseNumber: '',//执业证号
        startWorkDate: null,//执业时间
        address: '', //联系地址
        remark: '', //个人简介
        email: '',
        lawyerMobile: '',
        files: [],//附件
        lawFirmId: null, //所属律所
        lawFirmName: '',
        joinedDate: null //入职日期
      },

      idCardList: [],
      qcList: [],
      lnList: [],
      showPreview: false,
      viewFileData: {},
      fileOptsIDCards: {
        multiple: true,
        format: ['jpg', 'jpeg', 'png',],
        showUploadList: false,
        defauleFiles: [],
        data: {
          catalogName: "LAWYER"
        },
      },
      fileOptsQc: {
        multiple: true,
        format: ['jpg', 'jpeg', 'png',],
        showUploadList: false,
        defauleFiles: [],
        data: {
          catalogName: "LAWYER"
        },
      },
      fileOptsLn: {
        multiple: true,
        format: ['jpg', 'jpeg', 'png',],
        showUploadList: false,
        defauleFiles: [],
        data: {
          catalogName: "LAWYER"
        },
      },
      avatarOpts: {
        multiple: false,
        format: ['jpg', 'jpeg', 'png'],
        showUploadList: false,
        defauleFiles: [],
        type: 'select',
        data: {
          catalogName: "avatar"
        },
      },
      submitStatus: false,
      lawFirmOptions: [],
      addFirm: false,
      lawFirmFormValidate: {
        lawFirmName: [
          { required: true, validator: checkLirmName, trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, validator: checkSocialCreditCode, trigger: 'blur' }
        ],
        description: [
          { type: 'string', max: 255, message: '不能超过255个字符', trigger: 'blur' }
        ],
      },
      lawFirmForm: {
        title: '',
        id: '',
        lawFirmName: '',
        lawFirmType: '',
        address: '',
        firmCode: '',
        socialCreditCode: '',
        areaCode: '',
        areaCodes: [],
        zipCode: '',
        establishDate: '',
        tel: '',
        director: '',
        description: '',
        auditStatus: null,
        practiceStatus: null,
      },
      pageHtml: '',
    }
  },
  methods: {
    viewRZXY: function () {
      // this.getPageData('lawyerResidencyServiceAgreement')
      this.rzxyView = true
    },
    viewYSZC: function () {
      // this.getPageData('webPrivacyPolicy')
      this.yszcView = true
    },
    cancelRZXY: function () {
      this.rzxyView = false
    },
    cancelYSZC: function () {
      this.yszcView = false
    },
    changeLawFirm: function (item) {
      console.log('changeLawFirm', item)
      if (item) {
        this.lawyerForm.lawFirmName = item.label || ''
        this.lawyerForm.lawFirmId = item.value || null
      } else {
        this.lawyerForm.lawFirmName = ''
        this.lawyerForm.lawFirmId = null
      }
    },
    reportFirm: function () {
      this.lawFirmForm = {
        id: '',
        lawFirmName: '',
        lawFirmType: '',
        address: '',
        firmCode: '',
        socialCreditCode: '',
        areaCode: '',
        areaCodes: [],
        zipCode: '',
        establishDate: '',
        tel: '',
        director: '',
        description: '',
        auditStatus: null,
        practiceStatus: null,
      }
      this.$refs.lawFirmForm.resetFields()
      this.addFirm = true
    },
    cancelFirmEdit: function () {
      this.addFirm = false
    },
    saveFirm: function () {
      let that = this
      this.$refs["lawFirmForm"].validate(valid => {
        if (valid) {
          if (this.lawFirmForm.establishDate) this.lawFirmForm.establishDate = this.$moment(this.lawFirmForm.establishDate).format("YYYY-MM-DD")
          that.$axiosH5.post(that.$apis.common.reportFirm, that.lawFirmForm).then(res => {
            if (res.success) {
              that.$Message.success("上报成功！")
              that.getLawFirmOptions()
              that.cancelFirmEdit()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            that.$Message.error("上报失败！")
          })
        } else {
          return false
        }
      })
    },
    getPageData: function (pageType) {
      let params = new this.$URLSearchParams()
      params.append("pageType", pageType)
      this.$axiosH5.post('/appBaseSupport/pageData', params).then(res => {
        if (res.success) {
          let result = (res.result || {}).data
          this.pageHtml = result?.detail
          //解析HTML用到了插件mp-html,更多文档见：https://jin-yufeng.gitee.io/mp-html/#/overview/quickstart
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getLawFirmOptions: function () {
      let that = this
      this.$axiosH5.post(that.$apis.common.loadLawFirmAllOptions).then(res => {
        if (res.success) {
          that.lawFirmOptions = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('律所列表获取失败！')
      })
    },
    changePaperCode: function () {
      if (this.lawyerForm.paperCode) {
        this.lawyerForm.birthday = this.$common.discriCard(this.lawyerForm.paperCode, 'birthday')
        this.lawyerForm.gender = this.$common.discriCard(this.lawyerForm.paperCode, 'gender')
      }
    },
    uploadIDCards: function (data) {
      let that = this
      this.idCardList = data
      if (this.idCardList.length > 0) {
        this.idCardList.forEach(function (obj) {
          obj['subject'] = 'ID_CARD'
          obj['getFileType'] = that.$common.getFileType(obj.fileType)
        })
      }
    },
    handleRemoveIDCards: function (file) {
      const infileList = this.$refs.uploadIDCards.fileList
      this.$refs.uploadIDCards.fileList.splice(infileList.indexOf(file), 1)
      this.$refs["lawyerForm"].validateField('idCards')
    },
    uploadQc: function (data) {
      let that = this
      this.qcList = data
      if (this.qcList.length > 0) {
        this.qcList.forEach(function (obj) {
          obj['subject'] = 'LAWYER_QC'
          obj['getFileType'] = that.$common.getFileType(obj.fileType)
        })
      }
    },
    handleRemoveQc: function (file) {
      const infileList = this.$refs.uploadQc.fileList
      this.$refs.uploadQc.fileList.splice(infileList.indexOf(file), 1)
      this.$refs["lawyerForm"].validateField('qcs')
    },
    uploadLn: function (data) {
      let that = this
      this.lnList = data
      if (this.lnList.length > 0) {
        this.lnList.forEach(function (obj) {
          obj['subject'] = 'LAWYER_LN'
          obj['getFileType'] = that.$common.getFileType(obj.fileType)
        })
      }
    },
    handleRemoveLn: function (file) {
      const infileList = this.$refs.uploadLn.fileList
      this.$refs.uploadLn.fileList.splice(infileList.indexOf(file), 1)
      this.$refs["lawyerForm"].validateField('lns')
    },
    viewFile (item, index) {
      this.viewFileData = Object.assign({}, item)
      this.viewFileData.filePath = item.url
      this.showPreview = true
    },
    reset () {
      this.$refs["lawyerForm"].resetFields()
    },
    acceptRZXY: function () {
      this.checkBox = true
      this.cancelRZXY()
    },
    acceptYSZC: function () {
      this.checkBoxP = true
      this.cancelYSZC()
    },
    handleSubmit: function () {
      let that = this

      this.$refs["lawyerForm"].validate(valid => {
        if (valid) {
          if (!this.checkBox) {
            this.$Message.warning({
              content: '请阅读并同意《律师入驻服务协议》',
              duration: 5
            })
            return
          }
          if (!this.checkBoxP) {
            this.$Message.warning({
              content: '请阅读并同意《律师入驻保密与信息安全承诺书》',
              duration: 5
            })
            return
          }

          if (this.lawyerForm.birthday) {
            this.lawyerForm.birthday = this.$moment(this.lawyerForm.birthday).format('YYYY-MM-DD')
          }
          if (this.lawyerForm.startWorkDate) {
            this.lawyerForm.startWorkDate = this.$moment(this.lawyerForm.startWorkDate).format('YYYY-MM-DD')
          }
          if (this.lawyerForm.joinedDate) {
            this.lawyerForm.joinedDate = this.$moment(this.lawyerForm.joinedDate).format('YYYY-MM-DD')
          }
          that.lawyerForm.disabled = true
          that.lawFirmForm.paperType = 'ID_CARD'
          const files = [...that.idCardList, ...that.qcList, ...that.lnList]
          that.$set(that.lawyerForm, 'files', files)
          that.$set(that.lawyerForm, 'lnImgs', that.lnList)
          that.$set(that.lawyerForm, 'qcImgs', that.qcList)
          that.$set(that.lawyerForm, 'idImgs', that.idCardList)
          let formData = {
            lawyerName: that.lawyerForm.lawyerName,
            lawyerMobile: that.lawyerForm.lawyerMobile,
            lawyerEmail: that.lawyerForm.email,
            dataSource: 'PC',
            lawyerInfo: that.lawyerForm
          }
          that.$axiosH5.post(that.$apis.lawyerManagerApi.lawyerRegister.submit, formData).then(res => {
            if (res.success) {
              that.$Message.success("操作成功！")
              that.submitStatus = true
              // that.reset()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            that.$Message.error("操作失败！")
          })
        } else {
          return false
        }
      })
    },
    loadBaseInfo: function () {
      let that = this
      that.$axios.post('/loginInfo').then(res => {
        if (res.success) {
          let data = res.result || {}
          this.baseInfo = data.projectInfo || {}
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log("loadBaseInfo err", err)
        // that.$Message.error('获取失败！');
      })
    },
    initTree: async function () {
      let that = this
      that.regionData = await this.$baseData.handleData(false, that.$apis.dictionaryManager.region.getLvTree, null) || []
      // this.$axios.post(that.$apis.dictionaryManager.region.getLvTree).then(res => {
      //   if (res.success) {
      //     that.regionData = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error('区域数据获取失败！')
      // }).then(val => {
      // })
    }
  },
  beforeMount () {
    this.loadBaseInfo()
    this.getLawFirmOptions()
    this.initTree()
  }
}
</script>
<style lang="less" scope>
.lawyerRegisterMain {
  user-select: none;
  text-align: left;
  height: 100%;
  // overflow-y: auto;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;

  .lawyerRegisterHeader {
    height: 4rem;
    background: #fff;
    color: #333;
    display: flex;
    align-items: center;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .lawyerRegisterTitle {
      align-items: center;
      line-height: normal;
      font-weight: 700;
      font-style: normal;
      font-size: 1.4rem;
      display: flex;

      .logoIconC {
        width: 3rem;
        height: 3rem;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .lawyerRegisterTitleRight {
      span {
        display: flex;
        align-items: center;
        font-size: 0.85rem;
      }
    }
  }

  .lawyerRegisterBody {
    flex-grow: 1;
    overflow: hidden;
    padding: 10px;

    .lrMainConent {
      margin: 0 auto;
      height: 100%;
      // padding: 10px;
      overflow: hidden;
    }

    .lrContent {
      // width: 70%;
      min-width: 340px;
      max-width: 900px;
      margin: 0 auto;
      height: 100%;
      background-color: #ffffff;
      // border: 1px solid #c7ced4;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .lrTitleC {
        text-align: center;
        background: #f7f7f7;
        padding: 10px 20px;

        .lrTitleMain {
          font-size: 1rem;
          // line-height: 2.4rem;
          font-weight: 500;
          text-align: center;
        }

        .lrTitleDesc {
          font-size: 12px;
          margin-bottom: 5px;
        }
      }
      // padding: 20px;

      .formContent {
        flex-grow: 1;
        overflow-y: auto;
      }

      .lrSuccessC {
        flex-grow: 1;
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;

        .lrSuccess {
          display: flex;
          flex-direction: column;
          align-items: center;
          // padding: 2rem 20px;

          .lrSuccessTitle {
            font-size: 1.4rem;
            font-weight: 500;
            margin: 1rem 10px;
          }

          .lrSuccessDesc {
            font-size: 1rem;
            color: #888;
          }
        }
      }

      .partDivider {
        font-weight: 500;
        color: #333;
        font-size: 1rem;
        margin: 1rem 0;
        position: relative;
        padding-left: 1rem;
      }

      .partDivider::before {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        content: '';
        width: 4px;
        height: 1.2rem;
        background-color: #2d8cf0;
        border-radius: 4px;
      }
    }

    .checkBox {
      font-size: 0.9rem;
    }
  }

  .copyright {
    height: 32px;
    line-height: 32px;
    font-size: 0.8rem;
    text-align: center;
  }
}
</style>